import React from 'react';
import { MoreHorizontal } from 'lucide-react';

/**
 * Komponen navigasi bottom untuk mobile
 * @param {boolean} isDarkMode - Status dark mode
 * @param {Array} primaryItems - Menu items utama (maks 4)
 * @param {Array} secondaryItems - Menu items tambahan
 * @param {string} activeMenu - ID menu yang aktif
 * @param {function} onMenuClick - Callback saat menu diklik
 * @param {function} onMoreClick - Callback saat tombol "Lainnya" diklik
 */
const MobileBottomNav = ({
    isDarkMode,
    primaryItems,
    secondaryItems,
    activeMenu,
    onMenuClick,
    onMoreClick
}) => {
    const hasMoreItems = secondaryItems.length > 0;
    const isOthersActive = secondaryItems.some(
        item => item.id === activeMenu || item.subItems?.some(sub => sub.id === activeMenu)
    );

    /**
     * Mendapatkan class untuk item navigasi
     */
    const getItemClass = (isActive) => `
        flex flex-col items-center justify-center w-full h-full gap-1 transition-all 
        ${isActive ? (isDarkMode ? 'text-indigo-400' : 'text-indigo-600') : 'text-slate-500'}
    `;

    /**
     * Mendapatkan class untuk icon wrapper
     */
    const getIconWrapperClass = (isActive) => `
        p-1.5 rounded-xl transition-all 
        ${isActive ? (isDarkMode ? 'bg-indigo-900/20' : 'bg-indigo-50') : ''}
    `;

    return (
        <div className={`
            md:hidden fixed bottom-0 w-full h-[70px] border-t px-2 flex justify-around items-center z-50 
            ${isDarkMode ? 'bg-slate-900 border-slate-800' : 'bg-white border-slate-200'}
        `}>
            {/* Primary Menu Items */}
            {primaryItems.map((item) => {
                const isChildActive = item.subItems?.some(sub => sub.id === activeMenu);
                const isActive = activeMenu === item.id || isChildActive;

                return (
                    <button
                        key={item.id}
                        onClick={() => onMenuClick(item)}
                        className={getItemClass(isActive)}
                    >
                        <div className={getIconWrapperClass(isActive)}>
                            <item.icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                        </div>
                        <span className="text-[10px] font-medium truncate max-w-[60px]">
                            {item.label}
                        </span>
                    </button>
                );
            })}

            {/* More Button */}
            {hasMoreItems && (
                <button
                    onClick={onMoreClick}
                    className={`
                        flex flex-col items-center justify-center w-full h-full gap-1 transition-all 
                        ${isOthersActive
                            ? (isDarkMode ? 'text-indigo-400' : 'text-indigo-600')
                            : 'text-slate-500 hover:text-slate-700'
                        }
                    `}
                >
                    <div className={getIconWrapperClass(isOthersActive)}>
                        <MoreHorizontal size={20} strokeWidth={isOthersActive ? 2.5 : 2} />
                    </div>
                    <span className="text-[10px] font-medium">Lainnya</span>
                </button>
            )}
        </div>
    );
};

export default MobileBottomNav;
